import store from "@/state/store";

export default [
  {
    path: "/jogjadigdaya/beranda",
    name: "LandingPage",
    component: () => import("../views/pages/landing/landingPage.vue"),
    meta: {
      title: "Selamat Datang Jogja Digdaya",
    },
  },
  {
    path: "/jogjadigdaya/v2",
    name: "LandingPageV2",
    component: () => import("../views/pages/landing/data_old/landingPageV2.vue"),
    meta: {
      title: "Selamat Datang",
    },
  },
  {
    path: "/jogjadigdaya/about",
    name: "aboutPage",
    component: () => import("../views/pages/landing/aboutPage.vue"),
    meta: {
      title: "Tentang Kita",
    },
  },
  {
    path: "/jogjadigdaya/kebijakan-privasi",
    name: "privacyPolicy",
    component: () => import("../views/pages/landing/privacyPolicy.vue"),
    meta: {
      title: "Kebijakan Privasi",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "notFound",
    component: () => import("../views/pages/utility/404.vue"),
    meta: {
      title: "Halaman Tidak Ditemukan",
    },
  },
  {
    path: "/jogjadigdaya/laporan-sekolah",
    name: "laporanSekolah",
    component: () => import("../views/pages/landing/laporanSekolah.vue"),
    meta: {
      title: "Laporan Bencana Sekolah",
    },
  },
  {
    path: "/jogjadigdaya/detail-laporan-sekolah/:id",
    name: "detailLaporanSekolah",
    component: () => import("../views/pages/landing/detailLaporanSekolah.vue"),
    meta: {
      title: "Detail Laporan Bencana Sekolah",
    },
  },
  {
    path: "/jogjadigdaya/dashboard-emergency",
    name: "dashEmergency",
    component: () => import("../views/pages/landing/dashboard/dashEmergency.vue"),
    meta: {
      title: "Dashboard Pantauan Real-Time Kejadian",
    },
  },
  {
    path: "/jogjadigdaya/dashboard-korban-jiwa",
    name: "dashKorbanJiwa",
    component: () => import("../views/pages/landing/dashboard/dashKorbanJiwa.vue"),
    meta: {
      title: "Dashboard Korban Jiwa",
    },
  },
  {
    path: "/jogjadigdaya/dashboard-kerugian",
    name: "dashKerugian",
    component: () => import("../views/pages/landing/dashboard/dashKerugian.vue"),
    meta: {
      title: "Dashboard Kerugian",
    },
  },
  {
    path: "/jogjadigdaya/dashboard-kerusakan",
    name: "dashKerusakan",
    component: () => import("../views/pages/landing/dashboard/dashKerusakan.vue"),
    meta: {
      title: "Dashboard Kerusakan",
    },
  },
  {
    path: "/jogjadigdaya/dashboard-penanganan-awal",
    name: "dashPenangananAwal",
    component: () => import("../views/pages/landing/dashboard/dashPenangananAwal.vue"),
    meta: {
      title: "Dashboard Penanganan Awal",
    },
  },
  {
    path: "/jogjadigdaya/dashboard-kebutuhan-darurat",
    name: "dashKebutuhanDarurat",
    component: () => import("../views/pages/landing/dashboard/dashKebutuhanDarurat.vue"),
    meta: {
      title: "Dashboard Kebutuhan Darurat",
    },
  },
  {
    path: "/jogjadigdaya/login",
    name: "login",
    component: () => import("../views/pages/account/login"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({
            name: "home",
          });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/jogjadigdaya/register",
    name: "register",
    component: () => import("../views/pages/account/register"),
    meta: {
      title: "Register",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({
            name: "home",
          });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/jogjadigdaya/forgot-password",
    name: "Forgot-password",
    component: () => import("../views/pages/account/forgot-password"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({
            name: "home",
          });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/jogjadigdaya/logout",
    name: "logout",
    meta: {
      title: "Logout",
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        try {
          localStorage.removeItem("token");
          localStorage.removeItem("data_user");
          sessionStorage.removeItem("token");
          next({ name: "login" });
        } catch (error) {
          console.log("Failed to logout ", error);
          next({ name: "home" });
        }
      },
    },
  },
  {
    path: "/jogjadigdaya/",
    name: "home",
    meta: { title: "Dashboard", authRequired: true },
    component: () => import("../views/pages/dashboard/index"),
  },
  {
    path: "/jogjadigdaya/profil",
    name: "profil",
    meta: { title: "Profil", authRequired: true },
    component: () => import("../views/pages/contacts/profile"),
  },
  {
    path: "/jogjadigdaya/order",
    name: "orders",
    meta: { title: "Customer", authRequired: true },
    component: () => import("../views/pages/ecommerce/orders.vue"),
  },
  {
    path: "/jogjadigdaya/laporan",
    name: "laporan",
    meta: { title: "Laporan" },
    component: () => import("../views/pages/laporan/dash_laporan.vue"),
  },
  {
    path: "/jogjadigdaya/pdf/:id",
    name: "pdf",
    meta: { title: "PDF" },
    component: () => import("../views/pages/laporan/pdf.vue"),
  },
  {
    path: "/jogjadigdaya/laporan/detail-laporan/:id",
    name: "Detail Laporan",
    meta: { title: "Detail Laporan" },
    component: () => import("../views/pages/laporan/detail_laporan.vue"),
  },
  {
    path: "/jogjadigdaya/laporan/kontak",
    name: "kontakKami",
    meta: { title: "Data Kontak Kami" },
    component: () => import("../views/pages/laporan/kontak.vue"),
  },
  {
    path: "/jogjadigdaya/laporan/detail-laporan/update-laporan/:id/:idDampak/:idKebutuhan/:idPenanganan/:idKerugian/:idKerusakan/:idKorbanJiwa/:laporanKe",
    name: "Update Laporan Rutin",
    meta: { title: "Update Laporan Rutin" },
    component: () => import("../views/pages/laporan/update_laporan_rutin.vue"),
  },
  {
    path: "/jogjadigdaya/laporan/create-laporan",
    name: "addlaporan",
    meta: { title: "Dash Laporan" },
    component: () => import("../views/pages/laporan/laporan.vue"),
  },
  {
    path: "/jogjadigdaya/laporan/create-laporan/:id",
    name: "Laporan Dua",
    meta: { title: "Laporan kedua" },
    component: () => import("../views/pages/laporan/laporan_kedua.vue"),
  },
  {
    path: "/jogjadigdaya/laporan/inventory/:id",
    name: "Inventory",
    meta: { title: "Inventory" },
    component: () => import("../views/pages/laporan/inventory.vue"),
  },
  {
    path: "/jogjadigdaya/laporan/craete-inventory/:id",
    name: "CreateInventory",
    meta: { title: "Inventory" },
    component: () => import("../views/pages/laporan/create_inventory.vue"),
  },
  // bantuan
  {
    path: "/jogjadigdaya/laporan/bantuan/:id",
    name: "Bantuan",
    meta: { title: "Bantuan" },
    component: () => import("../views/pages/laporan/bantuan.vue"),
  },
  {
    path: "/jogjadigdaya/laporan/update-laporan/:id",
    name: "Update Laporan Awal",
    meta: { title: "Update Laporan" },
    component: () => import("../views/pages/laporan/update_laporan.vue"),
  },
  {
    path: "/jogjadigdaya/manajemen-user",
    name: "Manajemen User",
    meta: { title: "Manajemen User" },
    component: () => import("../views/pages/management/manajemen_user.vue"),
  },
  {
    path: "/jogjadigdaya/manajemen-user/create",
    name: "addUser",
    meta: { title: "Manajemen User" },
    component: () => import("../views/pages/management/form_user.vue"),
  },
  {
    path: "/jogjadigdaya/manajemen-user/update/:id",
    name: "updateUser",
    meta: { title: "Manajemen User" },
    component: () => import("../views/pages/management/form_user.vue"),
  },
  {
    path: "/jogjadigdaya/data-visualization",
    name: "Data Visualization",
    meta: { title: "Data Visualization" },
    // component: () => import("../views/pages/dashboard/data-visualization.vue"),
    component: () =>
      import("../views/pages/dashboard/data-visualization-meta.vue"),
  },
  {
    path: "/jogjadigdaya/penyalur-bantuan",
    name: "Penyalur Bantuan",
    meta: { title: "Penyalur Bantuan" },
    // component: () => import("../views/pages/dashboard/data-visualization.vue"),
    component: () => import("../views/pages/bantuan/penyalur_bantuan.vue"),
  },
  {
    path: "/jogjadigdaya/penyalur-bantuan/:id",
    name: "Detail Penyalur Bantuan",
    meta: { title: "Detail Penyalur Bantuan" },
    component: () => import("../views/pages/bantuan/detail_penyalur_bantuan.vue"),
  },
];
